import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { LearningGroups, SchoolClasses } from '.'
import { TestTakersStyles } from './Style'
import { CreateAssessmentsContext } from './CreateAssessmentsContext';
import FlatTestTakers from './FlatTestTakers';

const TestTakers = () => {
    const { hasLearningUnit, isSchoolsGroup} = useContext(CreateAssessmentsContext)

    const { headerFilters } = useSelector(state => state.header)

    return (
        <TestTakersStyles>
            {headerFilters?.affiliation ?
                (
                    hasLearningUnit ?
                        <FlatTestTakers /> :
                        (isSchoolsGroup ? <SchoolClasses /> : <LearningGroups />)
                )
                :
                <div className='select-affiliation-placeholder'>
                    {"בחר מוסד"}
                </div>
            }

        </TestTakersStyles>
    );
}

export default TestTakers
